import K_Loading from "../templates/K_Loading";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface LoadingOptions extends ComponentOptions {
    bsc?: string;
    message?: string;
    startPercent?: number | string;
}

export class Loading extends TemplateComponent {

    options: LoadingOptions;

    constructor(options: LoadingOptions) {
        super(K_Loading, options);
    }

    preRender() {
        const options = this.options;

        options.message = options.message || "";
        options.startPercent = options.startPercent ? options.startPercent + "%" : 0;
    }

}
